import React, { Component } from "react";
import { Typography } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";

class Timer extends Component {
    render()
    {
        let minute = Math.floor(this.props.roundTimer / 60);
        let seconds = this.props.roundTimer - minute * 60;

        return (
            <Typography variant="h5" color='primary'>TIME: {`${minute}:${seconds < 10 ? "0": ""}${seconds}`}</Typography>
        );
    };
};

const styles = theme => ({});

export default withStyles(styles)(Timer);